import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getUsersCount, type GetUsersParams } from '@apis/users';
import { dropEmptyValues } from '@utils/common';

export const useUserCount = (searchParam: GetUsersParams) => {
  const cleaned = dropEmptyValues(searchParam, ['username', 'name', 'group', 'status']);

  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['usersCount', cleaned],
    queryFn: () => getUsersCount(cleaned),
  };

  return useQuery(queryOptions);
};
